import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  staff: 0,
  lead: 0,
  task: 0,
  role: 0,
  dashboard: 0,
};

const refreshSlice = createSlice({
  name: "refresh",
  initialState,
  reducers: {
    triggerRefresh: (state, action) => {
      const key = action.payload;

      if (state[key] !== undefined) {
        state[key] += 1;
      }
    },
  },
});

export const { triggerRefresh } = refreshSlice.actions;
export default refreshSlice.reducer;